import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { backgroundOrange, black, border1, orange, textMuted } from '@/theme/colors'
import { media, radii } from '@/theme/tokens'
import { Button } from '@components/Button'
import { ShellRow } from '@components/Page'

/* Full-bleed band on the same treatment as the public SiteHeader: cream ground
   and a hairline under it. The horizontal gutter lives on HeaderContent (the
   shared ShellRow) so the brand lines up with the page content below. */
export const HeaderContainer = styled.header`
	background: ${backgroundOrange};
	border-bottom: 1px solid ${border1};
	padding: 16px 0;

	${media.phone} {
		padding: 10px 0;
	}
`

export const HeaderContent = styled(ShellRow)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
`

// The brand lockup is the shared @components/BrandMark atom (same as the
// public SiteHeader) — no local logo styles.

/** The brand as the way home: a link to My Trips around the lockup. */
export const BrandLink = styled(Link)`
	display: inline-flex;
	text-decoration: none;
	border-radius: ${radii.small};

	&:focus-visible {
		outline: 2px solid ${orange};
		outline-offset: 2px;
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`

/**
 * A nav action: the ghost Button. `$neutral` draws the account actions (profile,
 * logout) in dark grey, leaving orange to the ones that navigate the app.
 * `$collapse` leaves only the icon on phones.
 */
export const NavButton = styled(Button)<{ $collapse?: boolean; $neutral?: boolean }>`
	${({ $neutral }) =>
		$neutral &&
		css`
			color: ${textMuted};

			&:hover:not(:disabled) {
				color: ${black};
			}
		`}
	${({ $collapse }) =>
		$collapse &&
		css`
			${media.phone} {
				padding: 8px 8px;

				span {
					display: none;
				}
			}
		`}
`
